module.exports = __webpack_public_path__ + "static/media/img-colored-logo-text.1b9548ea.pdf";